import React from 'react'
import Link from 'redux-first-router-link'
import { LOGIN_PAGE } from 'constants/pages'
import { button } from '@groovehq/internal-design-system/lib/styles/elements'
import logo from 'assets/groove_logo_v2.svg'

import { styles } from './styles'

const Container = ({ children }) => {
  return (
    <>
      <div css={styles.header}>
        <div css={styles.logo}>
          <img src={logo} alt="GrooveHQ" />
        </div>
      </div>
      <div>{children}</div>
      <div css={styles.login}>
        <span>Already have an account?&nbsp;</span>
        <Link
          to={{ type: LOGIN_PAGE }}
          css={[button.styles.link, styles.loginLink]}
        >
          Log in
        </Link>
      </div>
    </>
  )
}

export default Container
